import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IMAGES } from '../mock/data';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const nav = useNavigate();
  return (
    <div className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-[#070609]">
      <img src={IMAGES.wetStreet} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 city-overlay" />
      <div className="absolute inset-0 vignette" />
      <div className="relative text-center px-4">
        <div className="font-display font-700 text-8xl md:text-9xl text-gradient-rp">404</div>
        <h1 className="font-display font-700 text-2xl text-white mt-2">This street doesn't exist</h1>
        <p className="mt-3 text-white/55 max-w-md mx-auto">You've wandered into an unmapped part of Xincity. The neon fades here.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <button onClick={() => nav('/city')} className="btn-neon rounded-xl px-6 py-3 font-600 flex items-center gap-2"><Home className="h-4 w-4" /> Back to the City</button>
          <button onClick={() => nav(-1)} className="btn-ghost rounded-xl px-6 py-3 font-600 flex items-center gap-2"><ArrowLeft className="h-4 w-4" /> Go Back</button>
        </div>
      </div>
    </div>
  );
}
